export function getAppLocale() {
  if (typeof document === 'undefined') {
    return 'en';
  }
  const rawLang = document.documentElement?.lang || 'en';
  const [canonical] = Intl.getCanonicalLocales(rawLang);
  return canonical ?? 'en';
}